import { createSelector } from "reselect";
import SelectionState from "state/selections/SelectionState";
import scope from "./scope";
import { memoize, uniqueByKey } from "@ls/js-utils";

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});

export const selectData = (state) => state[scope].data;
export const selectFetchingData = (state) => state[scope].fetchingData;

export const selectRowsMap = createSelector(
  selectDefinitions(SelectionState.COMMITTED),
  selectData,
  (selectedDurationToTargetDefinitions, durationToTargetData) => {
    if (!Array.isArray(durationToTargetData)) {
      console.error("unexpected response", durationToTargetData);
      return {};
    }

    return durationToTargetData.reduce((map, durationToTarget) => {
      const { majorEntityId, accountDurationRelativeToTarget } =
        durationToTarget;
      map[majorEntityId] = {};
      map[majorEntityId]["targetMajorAccountDuration"] =
        accountDurationRelativeToTarget;
      return map;
    }, {});
  }
);
